import StockPage from './StockPage';

export default StockPage;
